import styled from 'styled-components'

export default styled.section`
  max-width: 800px;
  width: 100%;
  margin: 50px auto;
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 16px;
  box-sizing: border-box;

  .spinner-container {
    display: flex;
    justify-content: center;
    padding: 48px 0;
  }

  h2 {
    margin: 0 0 12px;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${ ({ theme }) => theme.colors.greyDark };
  }

  .payment-method {
    .card {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;
      padding: 16px;
      border-radius: 12px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
      background-color: ${ ({ theme }) => theme.colors.white };
      cursor: pointer;
      text-decoration: none;
      color: ${ ({ theme }) => theme.colors.black };

      &:hover {
        border-color: ${ ({ theme }) => theme.colors.grey };
      }

      > img:first-child {
        width: 38px;
      }

      .number {
        flex: 1;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .add {
        flex: 1;
        color: ${ ({ theme }) => theme.colors.primary };
        font-weight: 600;
      }

      .arrow {
        width: 12px;
      }
    }
  }

  .passes {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .pass-card {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 12px;
    border: 1px solid ${ ({ theme }) => theme.colors.greyLight };
    background-color: ${ ({ theme }) => theme.colors.white };

    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      gap: 12px;

      .name {
        font-size: 18px;
        font-weight: 700;
      }

      .type {
        flex: 0 0 auto;
        padding: 2px 10px;
        border-radius: 12px;
        font-size: 13px;
        font-weight: 600;
        background-color: ${ ({ theme }) => theme.colors.lightPurple };
        color: ${ ({ theme }) => theme.colors.blueLight };
      }
    }

    .body {
      display: flex;
      flex-direction: row;
      gap: 32px;
      flex-wrap: wrap;

      .detail {
        display: flex;
        flex-direction: column;
        gap: 2px;

        .label {
          font-size: 13px;
          color: ${ ({ theme }) => theme.colors.greyDark };
        }

        .value {
          font-weight: 600;
        }
      }
    }

    &.available {
      cursor: pointer;

      &:hover {
        border-color: ${ ({ theme }) => theme.colors.grey };
      }

      .price {
        font-size: 18px;
        font-weight: 700;
        color: ${ ({ theme }) => theme.colors.primary };
      }
    }
  }

  .group-name {
    margin: 12px 0 8px;
    font-weight: 700;
  }

  .empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 32px 0;
    text-align: center;
    color: ${ ({ theme }) => theme.colors.greyDark };
  }

  .actions {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
`

export const StyledConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px 32px;
  min-width: 280px;

  .title {
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${ ({ theme }) => theme.colors.primary };
  }

  .name {
    font-size: 16px;
    text-align: center;
  }

  .price {
    font-size: 26px;
    font-weight: 700;
  }

  footer {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
  }
`
